enum CreativeGridView {
  LineItemForm = 'lineItemForm',
  LineItemModal = 'lineItemModal',
  LineItemSummary = 'lineItemSummary',
}

export default CreativeGridView;
